import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const quotes = [
  ["I uploaded our builder's floor plan at midnight and had a detailed quotation before my tea went cold. The final bill was within 4% of it.", "Ananya & Rohit", "3 BHK, Whitefield"],
  ["The transparency sold us — every wardrobe, every light, itemised. No surprise add-ons later.", "Karthik M.", "2 BHK, HSR Layout"],
  ["Their Premium package felt like Luxe. The team delivered our home in 48 days.", "Meera S.", "Villa, Sarjapur"],
];

export default function Testimonials() {
  return (
    <>
      <section id="stories" className="py-20 lg:py-28 bg-brand-sand" data-testid="testimonials-section">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <p className="text-xs uppercase tracking-[0.25em] text-brand-accent">Client stories</p>
          <div className="grid md:grid-cols-3 gap-6 mt-12">
            {quotes.map(([q, n, p]) => (
              <blockquote key={n} className="bg-brand-cream rounded-2xl p-8 border border-brand-line">
                <p className="font-serif-display text-2xl leading-snug text-brand-ink">“{q}”</p>
                <footer className="mt-8 text-sm"><span className="text-brand-ink">{n}</span><span className="text-brand-muted-light"> · {p}</span></footer>
              </blockquote>
            ))}
          </div>
        </div>
      </section>
      <section className="bg-brand-ink-soft grain relative" data-testid="cta-section">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 lg:py-24 flex flex-col md:flex-row md:items-center justify-between gap-8">
          <h2 className="font-serif-display text-4xl lg:text-6xl text-brand-cream max-w-2xl leading-tight">Know your budget <em className="text-brand-accent">before</em> you begin.</h2>
          <Link to="/estimate" className="group inline-flex items-center gap-3 rounded-full bg-brand-accent text-white px-8 py-4 text-sm hover:bg-brand-accent-dark transition-colors" data-testid="cta-estimate-btn">
            Get my instant quote <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </div>
      </section>
    </>
  );
}
